export default __webpack_public_path__ + "static/media/AppLogoIconMobile.7a214d01.svg";